// extracted by mini-css-extract-plugin
module.exports = {"noBr":"Item-module--noBr--3vaox","column":"Item-module--column--1YOVk","cell":"Item-module--cell--vt9Kr","label":"Item-module--label--2oVBj","text":"Item-module--text--344F2"};